<!--
 * @Author: wuhao
 * @Date: 2021-03-02 10:59:01
 * @LastEditors: wuhao
 * @LastEditTime: 2021-03-31 11:17:39
 * @Description: 封装select
-->
<template>
  <el-date-picker
    :value="value"
    v-bind="$attrs"
    :placeholder="placeholder"
    :value-format="finalValueFormat"
    v-on="$listeners"
    @change="onChange"
  />
</template>

<script>
import { t } from '@/locale'

export default {
  name: 'ApexDatePicker',
  props: {
    value: {
      type: [String, Number, Date, Array],
      default: null
    },
    placeholder: {
      type: String,
      default() {
        return t('select.placeholder')
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    valueFormat: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      innerOptions: [],
      finalValueFormat: 'yyyy-MM-dd'
    }
  },
  mounted() {
    this.$el.addEventListener('change', this.formatInputValue)
    const format = this.$children[0].format
    if (this.$children[0].type === 'datetime') {
      this.finalValueFormat = this.valueFormat || format || 'yyyy-MM-dd HH:mm:ss'
    } else {
      this.finalValueFormat = this.valueFormat || format || 'yyyy-MM-dd'
    }
  },
  methods: {
    onChange(val) {
      this.$emit('input', val)
    },
    formatInputValue() {
      const displayValue = this.$children[0].displayValue
      if (displayValue.includes('-') || displayValue.includes(':')) {
        return
      }
      if (displayValue.length > 7) {
        let value
        if (this.finalValueFormat === 'yyyy-MM-dd') {
          value = `${displayValue.slice(0, 4)}-${displayValue.slice(4, 6)}-${displayValue.slice(6, 8)}`
        }
        if (this.finalValueFormat === 'yyyy-MM-dd HH') {
          value = `${displayValue.slice(0, 4)}-${displayValue.slice(4, 6)}-${displayValue.slice(6, 8)} ${displayValue.slice(8, 10)} || '00'`
        }
        if (this.finalValueFormat === 'yyyy-MM-dd HH:mm') {
          value = `${displayValue.slice(0, 4)}-${displayValue.slice(4, 6)}-${displayValue.slice(6, 8)} ${displayValue.slice(8, 10) || '00'}:${displayValue.slice(10, 12) || '00'}`
        }
        if (this.finalValueFormat === 'yyyy-MM-dd HH:mm:ss') {
          value = `${displayValue.slice(0, 4)}-${displayValue.slice(4, 6)}-${displayValue.slice(6, 8)} ${displayValue.slice(8, 10) || '00'}:${displayValue.slice(10, 12) || '00'}:${displayValue.slice(12, 14) || '00'}`
        }
        this.$emit('input', value)
      }
    }
  }
}

</script>

<style lang='scss' scoped>
</style>
